/* eslint-disable camelcase */
import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { ORDER_TYPES } from 'src/constants/appConstants';

import {
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
    GET_TEMPLATE_DETAILS_SUCCESS,
    GET_TEMPLATE_DETAILS_FAILURE,
    SET_PRODUCT_TEMPLATE_REFINE_DATA,
    UPDATE_PRODUCT_TEMPLATE_SUCCESS,
    UPDATE_PRODUCT_TEMPLATE_FAILURE,
    CREATE_PRODUCT_TEMPLATE_SUCCESS,
    CREATE_PRODUCT_TEMPLATE_FAILURE,
    SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
    GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
    GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
    CHECK_DUPLICATE_TEMPLATE_SUCCESS,
    CHECK_DUPLICATE_TEMPLATE_FAILURE,
    getDropdownValues,
} from '../actions';

export function* getDetailedProductTemplates(action) {
    const resourceType = 'ORDER_TEMPLATE_B';
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder,
    }));
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate,
    }));
    const payload = { ...action.payload };
    delete payload.typeList;
    const params = convertObjectToQueryParams({
        ...payload,
        resourceType: resourceType,
    });
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templateslist?${params}&templateType=${
        isMastOrder || isMastOrderTemplate
            ? 'ZLC_MAST'
            : action.payload.typeList !== undefined
            ? action.payload.typeList
            : 'ALL'
    }`;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
            payload: result.templateList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            pagination: {
                pageNum: result.pageNo,
                pageLimit: result.pageSize,
            },
            totalNoOfResults: result.totalNoOfResults,
        });
        yield put({
            type: SET_PRODUCT_TEMPLATE_REFINE_DATA,
            payload: result.templateRefineData || {},
        });
        yield put({
            type: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
            payload: result.templateSubCategoryList || [],
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* getTemplateDetails(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${action.payload}?templateSubType=${
        action?.templatecategory ? action.templatecategory : 'USER'
    }`;
    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({
            type: GET_TEMPLATE_DETAILS_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_TEMPLATE_DETAILS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* checkDuplicatetemplate(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/validateTemplate?templateName=${encodeURIComponent(action.payload)}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: CHECK_DUPLICATE_TEMPLATE_SUCCESS,
            // payload: result,
            //  statusCode: result.statusCode,
            statusMessage: result.statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: CHECK_DUPLICATE_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

export function* createProductTemplate(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;
    // try {
    //     const result = yield axios
    //         .post(url, { ...action.payload })
    //         .then((response) => response.data);
    //     yield put({
    //         type: CREATE_PRODUCT_TEMPLATE_SUCCESS,
    //         payload: result || {},
    //     });
    // } catch (e) {
    //     console.log(e);
    //     yield put({
    //         type: CREATE_PRODUCT_TEMPLATE_FAILURE,
    //         statusCode: errorHandler('503'),
    //         statusMessage: e.Error,
    //     });
    // }
    let result;
    let insideCatch = false;
    let responseData;
    try {
        result = yield axios
            .post(url, { ...action.payload })
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    insideCatch = true;
                    responseData = error.response.data;
                }
                logUiErrorToBackend(error, {
                    apiEndPoint: url,
                    requestPayload: action?.payload || '',
                });
            });
        if (insideCatch) {
            yield put({
                type: CREATE_PRODUCT_TEMPLATE_FAILURE,
                statusCode: responseData.statusCode,
                statusMessage: responseData.statusDescription,
            });
            insideCatch = false;
        } else {
            yield put({
                type: CREATE_PRODUCT_TEMPLATE_SUCCESS,
                payload: result || {},
            });
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: CREATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: '422',
            statusMessage: errorHandler('422'),
        });
    }
}

export function* updateProductTemplate(action) {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;
    try {
        const result = yield axios
            .put(url, { ...action.payload })
            .then((response) => response.data);
        yield put({
            type: UPDATE_PRODUCT_TEMPLATE_SUCCESS,
            payload: result || {},
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: UPDATE_PRODUCT_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}

function mapOrderHistorySummaryToTemplateData(summaryData) {
    const orderBasicDetails = summaryData?.orderBasicDetails || {};
    const orderSummaryDetail = orderBasicDetails.orderSummaryDetail || {};
    const procedureDetail = orderBasicDetails.procedureDetail || {};
    const orderDetails = summaryData?.orderDetails || [];

    const accountCode =
        orderBasicDetails.accountNumber || orderSummaryDetail.accountCode || '';
    const accountName = orderBasicDetails.accountName || '';
    const physicianId = orderSummaryDetail.physicianId || '';
    const physicianName = orderSummaryDetail.physicianName || '';
    const districtCode = orderSummaryDetail.districtCode || '';
    const territoryCode = orderSummaryDetail.territoryCode || '';
    const procedureCode = procedureDetail.procedureCode || '';

    const setProducts = orderDetails.filter(
        (p) => p && p.isSet && !p.isBundleHeader
    );
    const itemProducts = orderDetails.filter(
        (p) => p && !p.isSet && !p.isBundleHeader
    );
    const isMastOrder = !!orderBasicDetails.isMastOrder;

    const shippingDetails = orderBasicDetails.shippingDetails || [];
    const transferRecipients = orderBasicDetails.transferRecipients || [];
    const firstShipping = shippingDetails[0] || {};
    const shippingRecipient = firstShipping.transferRecipient || {};
    const firstRecipient = transferRecipients[0] || {};

    const billToId = orderBasicDetails.billToNumber || orderBasicDetails.billToId || '';
    const billToName = orderBasicDetails.billToName || '';

    const careOfField =
        firstShipping.careOfField ||
        shippingRecipient.careOfField ||
        transferRecipients.find(
            (recipient) => recipient?.salesOrg === firstShipping?.salesOrg
        )?.careOfField ||
        firstRecipient.careOfField ||
        '';

    const shipToAccount = firstShipping.shipToAccount || '';

    return {
        accountsSelected: accountCode
            ? [{ accountId: accountCode, accountName }]
            : [],
        physiciansSelected: physicianId || physicianName
            ? [{ physicianId, name: physicianName }]
            : [],
        procedureSelected: procedureCode,
        districtUID: districtCode,
        territoryUID: territoryCode,
        setProducts,
        itemProducts,
        isMastOrder,
        setProductsCount: setProducts.length,
        itemProductsCount: itemProducts.reduce(
            (sum, p) => sum + (parseInt(p.quantity, 10) || 0),
            0
        ),
        templateType: isMastOrder ? 'SURGERY_MAST' : 'surgery',
        billToId,
        billToName,
        careOfField,
        shipToAccount,
    };
}

const getOrderHistoryProductCFN = (product) => {
    const productCFN = product?.productCFN || product?.cfn || '';
    return productCFN ? String(productCFN).split('.')[0] : '';
};

const getOrderHistoryProductIdentity = (product) => {
    const setType = product?.isSet ? 'set' : 'item';
    return `${getOrderHistoryProductCFN(product)}::${product?.salesOrg || ''}::${setType}`;
};

const isInvalidOrderHistoryProduct = (product) => (
    product?.isExcluded ||
    product?.isExclude ||
    product?.isExcludedItem ||
    product?.isExclusionItem ||
    product?.isExcludedExtraItem ||
    product?.isInvalidItemMsg ||
    product?.reservationSetErrorMessage ||
    getOrderHistoryProductCFN(product).includes('B33')
);

const getValidatedOrderHistoryProducts = (summaryData) => {
    const orderBasicDetails = summaryData?.orderBasicDetails || {};
    const orderSummaryDetail = orderBasicDetails.orderSummaryDetail || {};
    const orderDetails = (summaryData?.orderDetails || []).filter(
        (product) =>
            product &&
            !product.isBundleHeader &&
            (product.approval || '').toString().toUpperCase() !== 'UNAPPROVED' &&
            (!product.approvalStatus || product.approvalStatus === 'APPROVED')
    );
    const accountCode =
        orderBasicDetails.accountNumber || orderSummaryDetail.accountCode || '';

    if (!orderDetails.length || !accountCode) {
        return Promise.resolve({ valid: orderDetails, excluded: [] });
    }

    const productsBySalesOrg = orderDetails.reduce((products, product) => {
        const productCFN = getOrderHistoryProductCFN(product);
        if (!productCFN || !product.salesOrg) {
            return products;
        }
        products[product.salesOrg] = products[product.salesOrg] || [];
        products[product.salesOrg].push(productCFN);
        return products;
    }, {});

    const validationCalls = Object.keys(productsBySalesOrg).map((salesOrg) => {
        const url = `/occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/products/validateproduct?${convertObjectToQueryParams({
            productCFN: productsBySalesOrg[salesOrg].join(),
            salesOrg,
            soldToAccount: accountCode,
            orderType: ORDER_TYPES.surgery,
            isMastOrder: !!orderBasicDetails.isMastOrder,
        })}&uhOrder=false`;
        return axios.get(url).then((response) => response.data);
    });

    if (!validationCalls.length) {
        return Promise.resolve({ valid: orderDetails, excluded: [] });
    }

    return Promise.all(validationCalls).then((validationResults) => {
        const validatedProducts = validationResults.reduce(
            (products, result) => [...products, ...(result?.products || [])],
            []
        );
        const validProductIdentities = new Set(
            validatedProducts
                .filter((product) =>
                    !isInvalidOrderHistoryProduct(product) &&
                    (product?.approval || '').toString().toUpperCase() !== 'UNAPPROVED' &&
                    (!product.approvalStatus || product.approvalStatus === 'APPROVED')
                )
                .map((product) => {
                    const productCFN = getOrderHistoryProductCFN(product);
                    const sourceProduct = orderDetails.find((orderProduct) => {
                        const sourceCFN = getOrderHistoryProductCFN(orderProduct);
                        return (
                            sourceCFN === productCFN &&
                            (!product.salesOrg ||
                                orderProduct.salesOrg === product.salesOrg) &&
                            (product.isSet === undefined ||
                                orderProduct.isSet === product.isSet)
                        );
                    });
                    return getOrderHistoryProductIdentity({
                        ...product,
                        salesOrg: product.salesOrg || sourceProduct?.salesOrg,
                        isSet:
                            product.isSet !== undefined
                                ? product.isSet
                                : sourceProduct?.isSet,
                    });
                })
        );

        const valid = orderDetails.filter((product) =>
            validProductIdentities.has(getOrderHistoryProductIdentity(product))
        );
        const excluded = orderDetails.filter(
            (product) =>
                !validProductIdentities.has(
                    getOrderHistoryProductIdentity(product)
                )
        );
        return { valid, excluded };
    });
};

export function* getDataForTemplate(action) {
    const isFromOrderHistory = action.payload.isFromOrderHistory || false;
    const url = isFromOrderHistory
        ? `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/orderHistorySummary?${convertObjectToQueryParams({ myCaseRef: action.payload.MyCASERef, resourceType: 'ALL' })}`
        : `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${
        action.payload.MyCASERef
    }?isMyCASERef=true&templateType=${action.payload.templateType}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        const validationResult = isFromOrderHistory
            ? yield getValidatedOrderHistoryProducts(result)
            : undefined;
        const validatedOrderDetails = validationResult?.valid;
        const excludedOrderProducts = validationResult?.excluded || [];
        const payload = isFromOrderHistory
            ? mapOrderHistorySummaryToTemplateData({
                ...result,
                orderDetails: validatedOrderDetails,
            })
            : result;
        if (isFromOrderHistory && payload && excludedOrderProducts.length > 0) {
            payload.excludedProducts = excludedOrderProducts;
        }
        yield put({
            type: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
            payload: payload || {},
        });
        yield getDropdownValues({
            dropDownName: 'territories',
            value: payload && payload.districtUID,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
